<template>
    <div>
        <div class="print-footer-container" @click="printpage">
            <div class="print-text">{{ translate('Print') }}</div>
            <div class="icon-sb-footer-print">
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14 5V2H6V5H4V0H16V5H14ZM16 9.5C16.2833 9.5 16.5208 9.40417 16.7125 9.2125C16.9042 9.02083 17 8.78333 17 8.5C17 8.21667 16.9042 7.97917 16.7125 7.7875C16.5208 7.59583 16.2833 7.5 16 7.5C15.7167 7.5 15.4792 7.59583 15.2875 7.7875C15.0958 7.97917 15 8.21667 15 8.5C15 8.78333 15.0958 9.02083 15.2875 9.2125C15.4792 9.40417 15.7167 9.5 16 9.5ZM14 16V12H6V16H14ZM16 18H4V14H0V8C0 7.15 0.291667 6.4375 0.875 5.8625C1.45833 5.2875 2.16667 5 3 5H17C17.85 5 18.5625 5.2875 19.1375 5.8625C19.7125 6.4375 20 7.15 20 8V14H16V18ZM18 12V8C18 7.71667 17.9042 7.47917 17.7125 7.2875C17.5208 7.09583 17.2833 7 17 7H3C2.71667 7 2.47917 7.09583 2.2875 7.2875C2.09583 7.47917 2 7.71667 2 8V12H4V10H16V12H18Z"
                        fill="#3557FF" />
                </svg>

            </div>
        </div>
        <div v-if="isTooltipVisible" class="tooltip-print-slideshow">
            <div class="tooltip-header">
                {{ translate('What would you like to print?') }}
            </div>
            <div class="tooltip-options">
                <div class="option">
                    <input type="radio" id="complete" name="print-option" value="ss" v-model="selectedOption">
                    <label for="complete">{{ translate('Complete Slideshow') }}</label>
                </div>
                <div class="option">
                    <input type="radio" id="title-text" name="print-option" value="ttltxt" v-model="selectedOption">
                    <label for="title-text">{{ translate('Slide titles and text') }}, {{ translate('but no images') }}</label>
                </div>
                <div class="option">
                    <input type="radio" id="titles" name="print-option" value="ttl" v-model="selectedOption">
                    <label for="titles">{{ translate('Only titles') }}</label>
                </div>
            </div>
            <button class="tooltip-btn" :disabled="!selectedOption" @click="printSlideshow">
                <i class="print-icon">
                    <svg width="20" height="19" viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6 18.5C5.45 18.5 4.97917 18.3042 4.5875 17.9125C4.19583 17.5208 4 17.05 4 16.5V14.5H2C1.45 14.5 0.979167 14.3042 0.5875 13.9125C0.195833 13.5208 0 13.05 0 12.5V8.5C0 7.65 0.291667 6.9375 0.875 6.3625C1.45833 5.7875 2.16667 5.5 3 5.5H17C17.85 5.5 18.5625 5.7875 19.1375 6.3625C19.7125 6.9375 20 7.65 20 8.5V12.5C20 13.05 19.8042 13.5208 19.4125 13.9125C19.0208 14.3042 18.55 14.5 18 14.5H16V16.5C16 17.05 15.8042 17.5208 15.4125 17.9125C15.0208 18.3042 14.55 18.5 14 18.5H6ZM16 4.5H4V2.5C4 1.95 4.19583 1.47917 4.5875 1.0875C4.97917 0.695833 5.45 0.5 6 0.5H14C14.55 0.5 15.0208 0.695833 15.4125 1.0875C15.8042 1.47917 16 1.95 16 2.5V4.5ZM16 10C16.2833 10 16.5208 9.90417 16.7125 9.7125C16.9042 9.52083 17 9.28333 17 9C17 8.71667 16.9042 8.47917 16.7125 8.2875C16.5208 8.09583 16.2833 8 16 8C15.7167 8 15.4792 8.09583 15.2875 8.2875C15.0958 8.47917 15 8.71667 15 9C15 9.28333 15.0958 9.52083 15.2875 9.7125C15.4792 9.90417 15.7167 10 16 10ZM6 16.5H14V12.5H6V16.5Z" />
                    </svg>

                </i>
                <span>{{ translate('Print Now') }}</span>
            </button>
        </div>
    </div>

</template>

<script>
import { createApp, nextTick } from 'vue';
import PrintHeader from './PrintHeader.vue';
import debounce from 'lodash/debounce';
export default {
    data() {

        return {
            selectedOption: '',
            isTooltipVisible: false,
            isMobileorTablet: false
        }

    },
    mounted() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
        const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(userAgent) || /Macintosh/.test(navigator.userAgent);
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        if((isMobile || isTablet) && hasTouch && window.matchMedia("(max-width: 1025px)").matches)
        {
            this.isMobileorTablet = true;

        }

    },
    props: {

        isArticle: {
            type: Boolean,
            default: false
        },
        isSlideshow: {
            type: Boolean,
            default: false
        },
        sourcesData: {
            type: Object,
            default: {}
        },
        translate: {
            type: Function
        },
    },
    components: {
        PrintHeader
    },
    methods: {
        async printpage(event) {
            this.$vwmdPageLink({ moduleName: 'fm-shr_print' });
            if (this.isArticle) {
                await this.printArticle(event);
            } else if (this.isSlideshow) {
                this.isTooltipVisible = !this.isTooltipVisible;
                this.selectedOption = '';
            }
        },
        printNow() {
            window.print();

        },
        hideInstreamLoadedModules() {

            const removeInstreamLoadedStyle = `
                    @media print {
                        .adsbygoogle.adsbygoogle-noablate, .promo-instream-module, .ia-data-capture-module,
                        .instream-drug-mono, .cold-flu-driver, .social-promo-module, .flu-nl-module, .promo-nl-module, [id^="masterdiv_sw"]{
                            display: none !important; 
                        }
                    }
                    `;
            const removeInstreamLoadedElement = document.createElement('style');
            removeInstreamLoadedElement.id = 'instreamPrintStyles'; 
            removeInstreamLoadedElement.textContent = removeInstreamLoadedStyle;
            document.head.appendChild(removeInstreamLoadedElement);

        },
        async printSlideshow(event) {
            this.isTooltipVisible = false;
            const selectedOptionPrint = this.selectedOption;
            this.selectedOption = '';
            
            if(selectedOptionPrint === 'ss')
            {
                this.$vwmdPageLink({ moduleName: 'fm-shr_print-ss' });
            }
            else if(selectedOptionPrint === 'ttltxt')
            {
                this.$vwmdPageLink({ moduleName: 'fm-shr_print-ttltxt' });
            }
            else if(selectedOptionPrint === 'ttl')
            {
                this.$vwmdPageLink({ moduleName: 'fm-shr_print-ttl' });
            }

            const button = event.target;
            const ssContainers = document.getElementsByClassName('ss-inner-container');
            let ssContainer = null;

            ssContainer = Array.from(ssContainers).find(container => container.contains(button));

            if (ssContainer) {

                this.hideInstreamLoadedModules();

                const sourceDiv = document.createElement('div');
                sourceDiv.innerHTML = this.sourcesData;
                sourceDiv.style.display = 'none';
                sourceDiv.classList.add('print-source');

                if (!document.getElementsByClassName('print-source').length) {
                    ssContainer.appendChild(sourceDiv);
                }

                const headerContainer = document.createElement('div');
                ssContainer.parentNode.insertBefore(headerContainer, ssContainer);
                const app = createApp(PrintHeader);

                if (!document.getElementsByClassName('print-header').length) {
                    app.mount(headerContainer);
                }

                document.body.classList.add('print-active');
                ssContainer.classList.add('print');

                if (selectedOptionPrint === 'ttltxt' || selectedOptionPrint === 'ttl') {
                    const printStyles = `
                        @media print {
                        .slide-image {
                            display: none !important; 
                        }
                        .slide-count-bbl {
                            display: none !important;
                        }
                    }
                    `;

                    const styleElement = document.createElement('style');
                    styleElement.id = 'printStyles'; 
                    styleElement.textContent = printStyles;

                    document.head.appendChild(styleElement);

                    if (selectedOptionPrint === 'ttl') {     
                        const printStylesTtl = `
                        @media print {
                        .slide .caption {
                            display: none !important; 
                        }
                    }`;

                    const styleElementTtl =  document.createElement('style');
                    styleElementTtl.id = 'printStylesTtl'
                    styleElementTtl.textContent = printStylesTtl;

                    document.head.appendChild(styleElementTtl);
                    }
                }
                await new Promise(resolve => setTimeout(resolve, 500));

                const afterPrintHandler = () => {
                    document.body.classList.remove('print-active');
                    ssContainer.classList.remove('print');

                    app.unmount();
                    headerContainer.remove();
                    sourceDiv.remove();

                    window.removeEventListener('afterprint', afterPrintHandler);
                    window.removeEventListener('touchstart', afterPrintHandler);

                    const styleElement = document.getElementById('printStyles');
                    if (styleElement) {
                        styleElement.remove();
                    }
                    const styleElementTtl = document.getElementById('printStylesTtl');
                    if(styleElementTtl) {
                        styleElementTtl.remove();
                    }
                    const removeInstreamModuleStyles = document.getElementById('instreamPrintStyles');
                    if(removeInstreamModuleStyles) {
                        removeInstreamModuleStyles.remove();
                    }
                };

                this.printNow();

                if(this.isMobileorTablet)
                {
                    window.addEventListener('touchstart',afterPrintHandler);

                }
                else
                {
                    this.handleDebounce = debounce(afterPrintHandler, 500);
                    window.addEventListener('afterprint', this.handleDebounce);
                }
            }
        },
        async printArticle(event) {
            const button = event.target;
            const articleContainers = document.getElementsByClassName('inner-article-container');
            let articleContainer = null;

            // Find the container having the clicked button
            articleContainer = Array.from(articleContainers).find(container => container.contains(button));

            if (articleContainer) {

                this.hideInstreamLoadedModules();

                const sourceDiv = document.createElement('div');
                sourceDiv.innerHTML = this.sourcesData;
                sourceDiv.style.display = 'none';
                sourceDiv.classList.add('print-source');

                if (!document.getElementsByClassName('print-source').length) {
                    articleContainer.appendChild(sourceDiv);
                }

                const headerContainer = document.createElement('div');
                articleContainer.parentNode.insertBefore(headerContainer, articleContainer);
                const app = createApp(PrintHeader);

                if (!document.getElementsByClassName('print-header').length) {
                    app.mount(headerContainer);
                }
            

                document.body.classList.add('print-active');
                articleContainer.classList.add('print');

                await new Promise(resolve => setTimeout(resolve, 500));

                const afterPrintHandler = () => {
                    document.body.classList.remove('print-active');
                    articleContainer.classList.remove('print');
                    
                    app.unmount();
                    headerContainer.remove();
                    sourceDiv.remove();

                    const removeInstreamModuleStyles = document.getElementById('instreamPrintStyles');
                    if(removeInstreamModuleStyles) {
                        removeInstreamModuleStyles.remove();
                    }

                    window.removeEventListener('afterprint', afterPrintHandler);
                    window.removeEventListener('touchstart',afterPrintHandler);
                };

                this.printNow();

                if(this.isMobileorTablet)
                {
                    window.addEventListener('touchstart',afterPrintHandler);

                }
                else
                {
                    this.handleDebounce = debounce(afterPrintHandler, 500);
                    window.addEventListener('afterprint', this.handleDebounce);
                }

            }

        },
    }

};
</script>

<style lang="scss" scoped>
$small-desktop: 64rem;
$lavender: #CCCCE7;
$ultramarine: #3557FF;
$carbon: #1B1B1B;
$white: #FFF;
$wave: #D2D9FF;
$shadow: #ddd;

.print-footer-container {
    align-items: center;
    display: flex;
    gap: 0.313rem;
    justify-content: center;
    margin-left: 1.4375rem;

    &:hover {
        cursor: pointer;
    }

    .print-text {
        color: $carbon;
        font-size: 0.875rem;
        font-weight: 400;
    }

    .icon-sb-footer-print {
        align-items: center;
        background: $white;
        border-radius: 50%;
        color: $ultramarine;
        display: flex;
        height: 2.5rem;
        justify-content: center;
        width: 2.5rem;
    }

    &:hover {
        .icon-sb-footer-print {
            @media (min-width: $small-desktop) {
                background-color: $wave;
            }
        }
    }
}

.tooltip-print-slideshow {
    background-color: #FFF;
    box-shadow: 0 1px 2px 2px $shadow;
    border-radius: 0.25rem;
    display: grid;
    gap: 0.75rem;
    margin-left: -6.5rem;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    position: absolute;
    z-index: 99999;

    &::before {
        background-color: $white;
        box-shadow: -5px -5px 3px -5px #999;
        content: '';
        height: 1.25rem;
        left: 50%;
        position: absolute;
        top: -4px;
        transform: rotate(45deg);
        width: 1.25rem;
    }

    .tooltip-header {
        color: #00157C;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.8rem;
    }

    .tooltip-options {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        padding-top: 0.75rem;
        width: 16.6rem;

        .option {
            align-items: center;
            display: flex;
            gap: 0.5rem;
            justify-content: left;

            input[type="radio"] {
                -moz-appearance: none;
                -webkit-appearance: none;
                appearance: none;
                background-color: $white;
                border: 2px solid $ultramarine;
                border-radius: 50%;
                cursor: pointer;
                flex: 0 0 auto; 
                height: 1.25rem;
                margin-right: 0.5rem;
                outline: none;
                position: relative;
                width: 1.25rem;

                &:checked::before {
                    background: $ultramarine;
                    border-radius: 50%;
                    content: '';
                    display: block;
                    height: 0.625rem;
                    left: 50%;
                    position: absolute;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 0.625rem;
                }
            }

            label {
                color: $carbon;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.6rem;
            }
        }
    }

    .tooltip-btn {
        align-items: center;
        background-color: $ultramarine;
        border: none;
        border-radius: 0.25rem;
        color: $white;
        cursor: pointer;
        display: flex;
        flex-direction: row-reverse;
        font-size: 1.125rem;
        font-weight: 600;
        gap: 0.5rem;
        justify-content: center;
        line-height: 1.8rem;
        padding: 0.5rem 0.5rem 0.5rem 1rem;
        width: 100%;

        svg {
            fill: $white;
            display: flex;
        }

        &:disabled {
            background: #B3B3B3;
            color: #676767;

            svg {
                fill: #676767;
            }
        }
    }
}
</style>
